import { Component } from '@angular/core';

import { Unit } from '@camelot/services';
import { TranslatePipe } from '@camelot/translation';

import { CamTranslationCore } from '../../../../../translation.service';
import { AbstractCellComponent } from '../../abstract';

export const unitLabel = (defaultUnit: number) => `core.default-unit.${Unit[defaultUnit]?.toLowerCase() ?? 'unknown'}`;

@Component({
  host: { 'data-cid': 'grid-unit-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [TranslatePipe],
  template: `
    @if (this.value !== null && this.value !== undefined) {
      {{ this.unitLabel(this.value) | translate }}
    }
  `,
})
export class GridUnitCellComponent extends AbstractCellComponent<unknown, number> {
  public Unit = Unit;
  public unitLabel = unitLabel;

  constructor() {
    super();
    CamTranslationCore.getInstance();
  }
}
